import type { Document } from '@contentful/rich-text-types'
import { useRouter } from 'next/router'

import { Divider } from '@cbhq/cds-web/layout'
import { Modal } from '@cbhq/cds-web/overlays/Modal/Modal'
import { ModalBody } from '@cbhq/cds-web/overlays/Modal/ModalBody'
import { ModalHeader } from '@cbhq/cds-web/overlays/Modal/ModalHeader'
import {
  AnalyticsProvider,
  Button,
  Div,
  ErrorBoundary,
  RichText,
} from '@cbhq/cdx-components'

// CDS ModalBody expects CDS elements as children — cast to any to allow ReactNode
const GateModalBody = ModalBody as any

export type AccreditedInvestorGateComponentProps = {
  pdfUrl?: string
  pdfTitle?: string
  modalTitle?: string
  modalDescription?: Document
  confirmButtonLabel?: string
  denyButtonLabel?: string
}

export function AccreditedInvestorGateComponent({
  pdfUrl,
  pdfTitle,
  modalTitle = 'Accredited Investor Verification',
  modalDescription,
  confirmButtonLabel = 'Yes, I am an accredited investor',
  denyButtonLabel = 'No, take me back',
}: AccreditedInvestorGateComponentProps) {
  const router = useRouter()

  const handleConfirm = () => {
    window.open(pdfUrl, '_blank', 'noopener,noreferrer')
    router.push('/')
  }
  const handleDeny = () => router.push('/')

  return (
    <ErrorBoundary>
      <AnalyticsProvider analyticsPrefix="AccreditedInvestorGate">
        <div style={{ minHeight: '100vh' }}>
          <Modal visible onRequestClose={handleDeny}>
            <ModalHeader title={modalTitle} />
            <GateModalBody>
              <Div flexDirection="column" spacing={2}>
                {modalDescription && <RichText content={modalDescription} />}
              </Div>
            </GateModalBody>
            <Divider />
            <Div
              spacing={3}
              flexDirection={{ sm: 'column', md: 'row' }}
              gap={{ sm: 2, md: 1 }}
              width="100%"
            >
              <Button onPress={handleDeny} variant="secondary" block>
                {denyButtonLabel}
              </Button>
              <Button onPress={() => handleConfirm()} variant="primary" block>
                {confirmButtonLabel}
              </Button>
            </Div>
          </Modal>
        </div>
      </AnalyticsProvider>
    </ErrorBoundary>
  )
}
